import { Component, Input, Output, EventEmitter, computed, signal, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-demande-documents-section',
  standalone: false,
  templateUrl: './demande-documents-section.component.html',
})
export class DemandeDocumentsSectionComponent implements OnChanges {
  @Input() documents: any[] = [];
  @Output() viewDocument = new EventEmitter<any>();

  private _documents = signal<any[]>([]);

  groupedDocs = computed(() => {
    const docs = this._documents();
    const map = new Map<string, { document_type: string; document_name_fr: string; document_name_ar: string; files: any[] }>();
    for (const doc of docs) {
      const key = doc.document_type || doc.file_name;
      if (!map.has(key)) map.set(key, { document_type: doc.document_type, document_name_fr: doc.document_name_fr, document_name_ar: doc.document_name_ar, files: [] });
      map.get(key)!.files.push(doc);
    }
    return Array.from(map.values());
  });

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['documents']) {
      this._documents.set(this.documents || []);
    }
  }

  onView(file: any): void {
    this.viewDocument.emit(file);
  }

  onDownload(file: any): void {
    const url = file?.serve_url || file?.file_link;
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
